import { useMemo } from 'react'

import { useSession } from '@rewardops/auth'
import {
  ContentfulAdBanner,
  HeroBannerSlide,
  PromotionBannerProps,
} from '@rewardops/utils'

type WLBannerProps = ContentfulAdBanner | HeroBannerSlide | PromotionBannerProps

const useFilterBySegmentationTags = <
  T extends WLBannerProps | WLBannerProps[],
>({
  bannerContent,
}: {
  bannerContent: T
}) => {
  const { data: session } = useSession()

  const data = useMemo(() => {
    const filterItem = (item: WLBannerProps) => {
      const segmentationTags = item?.segmentationTags
        ?.split(',')
        ?.map((tag) => tag.trim())
        ?.filter(Boolean)

      if (session?.user) {
        if (segmentationTags?.length) {
          const userTags = [
            session?.user?.member?.segmentCode,
            ...(session?.user?.member?.memberTags ?? []),
          ]?.filter(Boolean)

          const match = segmentationTags.some((tag) => userTags?.includes(tag))

          return match
        }

        return true
      }

      // if user not logged in and the banner has segmentation tags then exclude
      if (segmentationTags?.length) {
        return false
      }

      return true
    }

    if (Array.isArray(bannerContent)) {
      return bannerContent.filter(filterItem) as T
    }

    return filterItem(bannerContent) ? bannerContent : null
  }, [Boolean(session?.user), bannerContent])

  return data
}

export { useFilterBySegmentationTags }
